import { Component, OnInit } from '@angular/core';
import { Request } from '../_service/request';
import { ActivatedRoute, Params, Router } from '@angular/router';


@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {

  constructor(
    private request: Request,
    private router: Router,
  ) { }

  serverUrl = this.request.server_url;

  // server_url = "abc.com";

  actionName1 = ""
  actionName2 = ""
  actionName3 = ""
  actionName4 = ""
  actionName5 = ""
  actionName6 = ""
  actionName7 = ""
  actionName8 = ""
  actionName9 = ""
  actionName10 = ""
  actionName11 = ""
  actionName12 = ""
  actionName13 = ""
  actionName14 = ""


  section1: any;
  section2: any;
  section3: any;
  section4: any;
  section5: any;
  section6: any;
  section7: any;
  section8: any;
  section9: any;
  section10: any;
  section11: any;
  section12: any;
  section13: any;
  section14: any;
  section1Thumb: any;
  section2Thumb: any;
  section3Thumb: any;
  section4Thumb: any;
  section5Thumb: any;
  section6Thumb: any;
  section7Thumb: any;
  section8Thumb: any;
  section9Thumb: any;
  section10Thumb: any;
  section11Thumb: any;
  section12Thumb: any;
  section13Thumb: any;
  section14Thumb: any;
  isSearchClicked: boolean = false;

  searchlocation: any;
  searchType: any;
  locationSearchResults: any;
  typeSearchResult: any;
  locationSearchTxt: any;
  typeSearchTxt: any;
  ngOnInit(): void {
    this.getLocation()
    this.getSectionAimgs()
  }

  async getLocation() {
    let temp = this.request.get_structure('get_location', 'format');
    temp = await this.request.post(0, 'get_location', temp);
    // console.log(temp);
    // console.log(temp[1]['response']['data']);
    if (temp[0] == 200) {
      this.searchlocation = temp[1]['response']['data']['location'];
      this.searchType = temp[1]['response']['data']['property_type_list']
    }
    // console.log(this.searchlocation)
  }



  onsearchLocationChange(value, event) {
    console.log(event.keyCode, "event")

    this.locationSearchTxt = value;
    if (value) {
      this.locationSearchResults = [...this.searchlocation]
      // console.log(this.locationSearchResults)
      this.locationSearchResults = this.locationSearchResults.filter(data => {
        if (data.location.toUpperCase().includes(value.toUpperCase())) {
          return data
        }
      }).sort((a, b) => { return this.sortStringInJson(a, b, "location") }).filter((data, index) => {
        if (index < 5)
          return data;
      })
    }
    console.log(this.locationSearchResults)
    if (event.keyCode == 13) {
      let data = this.locationSearchResults[0]?.location_id
      if (this.locationSearchResults[0]?.location_id == null) { this.onSearchClick(0) }
      else {
        this.onSearchClick(data)
      }
    }
  }

  onsearchTypeChange(value) {
    this.typeSearchTxt = value
    if (value) {
      this.typeSearchResult = [...this.searchType]
      console.log(this.typeSearchResult)
      this.typeSearchResult = this.typeSearchResult.filter(data => {
        if (data.property_type.toUpperCase().includes(value.toUpperCase())) {
          return data
        }
      }).sort((a, b) => { return this.sortStringInJson(a, b, "property_type") }).filter((data, index) => {
        if (index < 5)
          return data;
      })
    }
  }

  sortStringInJson(a, b, key) {
    // console.log(a, b, key)
    let nameA = a[key].toUpperCase();
    let nameB = b[key].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // if this line is seen, names must be equal
    return 0;
  }

  async getSectionAimgs() {
    let temp = this.request.get_structure('get_images1', 'format');
    temp = await this.request.post(0, 'get_images1', temp);
    console.log(temp[1]['response']['data'])
    if (temp[0] == 200) {
      this.section1 = temp[1]['response']['data']['property_list']['sectionA'];
      this.section1Thumb = temp[1]['response']['data']['property_list']['sectionAthumb']
      this.section2 = temp[1]['response']['data']['property_list']['sectionB'];
      this.section2Thumb = temp[1]['response']['data']['property_list']['sectionBthumb'];
      this.section3 = temp[1]['response']['data']['property_list']['sectionC'];
      this.section3Thumb = temp[1]['response']['data']['property_list']['sectionCthumb'];
      this.section4 = temp[1]['response']['data']['property_list']['sectionD'][0];
      this.section5 = temp[1]['response']['data']['property_list']['sectionE'][0];
      this.section6 = temp[1]['response']['data']['property_list']['sectionF'][0];
      this.actionName1 = this.section1[0].location
      this.actionName2 = this.section2[0].location
      this.actionName3 = this.section3[0].location
      this.actionName4 = this.section4.location
      this.actionName5 = this.section5.location
      this.actionName6 = this.section6.location
      this.getSecondLayoutData()
    }
  }

  async getSecondLayoutData() {
    let temp = this.request.get_structure('get_images2', 'format');
    temp = await this.request.post(0, 'get_images2', temp);
    console.log(temp[1]['response']['data'])
    this.section7 = temp[1]['response']['data']['property_list']['sectionG'];
    this.section7Thumb = temp[1]['response']['data']['property_list']['sectionGthumb']
    this.section8 = temp[1]['response']['data']['property_list']['sectionH'];
    this.section8Thumb = temp[1]['response']['data']['property_list']['sectionHthumb']
    // this.section9 = temp[1]['response']['data']['property_list']['sectionI'];
    // this.section9Thumb = temp[1]['response']['data']['property_list']['sectionIthumb']
    this.section10 = temp[1]['response']['data']['property_list']['sectionJ'];
    this.section10Thumb = temp[1]['response']['data']['property_list']['sectionJthumb']
    this.section11 = temp[1]['response']['data']['property_list']['sectionK'];
    this.section11Thumb = temp[1]['response']['data']['property_list']['sectionKthumb']
    this.section12 = temp[1]['response']['data']['property_list']['sectionL'][0];
    this.section13 = temp[1]['response']['data']['property_list']['sectionL'][1];
    this.section14 = temp[1]['response']['data']['property_list']['sectionL'][2];

    // temprorary

    this.section9 = temp[1]['response']['data']['property_list']['sectionM'];
    this.section9Thumb = temp[1]['response']['data']['property_list']['sectionMthumb']

    // 
    this.actionName7 = this.section7[0].location
    this.actionName8 = this.section8[0].location
    this.actionName9 = this.section9[0].location
    this.actionName10 = this.section10[0].location
    this.actionName11 = this.section11[0].location


    let reddish = this.section11[0].property_subtitle.split(",")
    console.log(reddish, "reddish")

    let myArray1 = this.section12.location.split(",");
    if (this.section12.city == '') {
      this.actionName12 = this.section12.location
    } else if (this.section12.city != "") {
      this.actionName12 = this.section12.city + myArray1[1];
    }
    // this.actionName12 = this.section12.location


    let myArray2 = this.section13.location.split(",");
    if (this.section13.city == '') {
      this.actionName13 = this.section13.location
    } else if (this.section13.city != "") {
      this.actionName13 = this.section13.city + myArray2[1];
    }
    // this.actionName13 = this.section12.location
console.log(myArray2,"eeeeeeeeeeeeeeeeeeeeeeeee");


    let myArray3 = this.section14.location.split(",");
    if (this.section14.city == '') {
      this.actionName14 = this.section14.location
    } else if (this.section14.city != "") {
      this.actionName14 = this.section14.city + myArray3[1];
    }
    // this.actionName14 = this.section12.location
  }


  propertySearchResult: any;
  propertySearchResultLocation: any;
  propertySearchResultType: any;
  emptySearchResult: boolean = false;


  async onSearchClick(data) {
    var e = (<HTMLInputElement>document.getElementById("type")).value;
    let data1 = Number(e)
    console.log(data);
    if (data == 0 || this.locationSearchResults == null) {
      console.log('sfkhbgjh')
    }
    else if (data == "" || data == null) {
      console.log('called')
      this.emptySearchResult = true;
      this.isSearchClicked = true
    }
    else if (this.locationSearchResults.length > 0) {
      this.emptySearchResult = false;
      let temp = this.request.get_structure('getSearchProduct', 'format')
      temp.location_id = data;
      temp.property_type = Number(data1)
      console.log(temp)
      temp = await this.request.post(0, 'getSearchProduct', temp)
      console.log(temp);
      if (temp[0] == 200) {
        this.isSearchClicked = true
        let propList = temp[1]['response']['data']['property_list']
        if (propList.length > 0) {
          this.propertySearchResult = temp[1]['response']['data']['property_list']
          this.propertySearchResultLocation = temp[1]['response']['data']['search_location']
          this.propertySearchResultType = temp[1]['response']['data']['search_type']
        } else {
          this.propertySearchResult = null
        }
      } else if (temp[0] == 400) {
        this.emptySearchResult = true;
        this.isSearchClicked = true
      }
    }
  }

  onClearClick() {
    this.isSearchClicked = false;
    this.locationSearchResults = '';
    this.propertySearchResult = '';
    this.typeSearchResult = '';
  }

  getPropId(product_id) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    console.log(product_id)
    this.router.navigateByUrl("/desc?pid=" + product_id);
  }

  viewPropDetails(product_id) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.router.navigateByUrl("/desc?pid=" + product_id);
  }

}
